import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import NoIndex from "../components/NoIndex";

export default function Orders() {
  const { user, loading } = useAuth();
  const [orders, setOrders] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/", { replace: true });
      return;
    }
    api.get("/me/orders", { withCredentials: true })
      .then(({ data }) => setOrders(data))
      .catch(() => setOrders([]));
  }, [user, loading, navigate]);

  if (loading || orders === null || !user) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-20 text-center font-display text-2xl">
        Loading...
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12" data-testid="orders-page">
      <NoIndex title="My Orders" />
      <h1 className="font-display text-5xl uppercase leading-none mb-2">My Orders</h1>
      <p className="opacity-70 mb-8">All your past Playworld hauls.</p>

      {orders.length === 0 ? (
        <div className="pw-card p-10 text-center" data-testid="orders-empty">
          <p className="font-display text-2xl mb-4">No orders yet</p>
          <p className="mb-6 opacity-70">Time to start your collection!</p>
          <Link to="/shop" className="pw-btn">Browse Merch</Link>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div
              key={o.session_id}
              className="pw-card p-5"
              data-testid={`order-${o.session_id}`}
            >
              <div className="flex justify-between items-start flex-wrap gap-2 mb-3">
                <div>
                  <p className="font-bold">Order #{o.session_id.slice(-8).toUpperCase()}</p>
                  <p className="text-xs opacity-60">
                    {new Date(o.created_at).toLocaleDateString(undefined, {
                      year: "numeric", month: "short", day: "numeric",
                    })}
                  </p>
                </div>
                <span className="pw-badge green">PAID</span>
              </div>
              <div className="space-y-1">
                {(o.items || []).map((it, idx) => (
                  <div key={idx} className="flex justify-between text-sm">
                    <span>
                      {it.name}
                      {it.size ? ` (${it.size})` : ""} × {it.quantity}
                    </span>
                    <span className="font-bold">
                      ${(it.line_total ?? it.price * it.quantity).toFixed(2)}
                    </span>
                  </div>
                ))}
              </div>
              <div className="border-t-2 border-black mt-3 pt-3 flex justify-between font-display text-xl">
                <span>Total</span>
                <span>${o.amount.toFixed(2)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
